exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carousel__multiple-items button.slick-arrow.slick-next::before,\n.carousel__multiple-items button.slick-arrow.slick-prev::before {\n  color: #00b1e0;\n  font-size: 30px;\n}\n", ""]);
